module.exports = __webpack_public_path__ + "static/media/birthday.72ffc866.svg";